import { useState } from 'react'
import './HomePage.css'
import {
  Table,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableCell,
  TextField
} from '@wwnds/react';

const HomePage = ({ directories }) => {

  const [searchTerm, setSearchTerm] = useState("")
  const handleSearch = (e) => {
    setSearchTerm(e.target.value)
  }

  const parseProj = (project) => {
    if (project === "enjmusic5ess") {
      return "https://ilg.wwnorton.com/enjmusic4ess/"
    } else if (project === "soundscapes3update") {
      return "https://wwnorton.com/college/music/iLG/scapes3/"
    }
  }

  return (
    <div className="homepage-container">
      <TextField
        description="Enter search term"
        value={searchTerm}
        onChange={handleSearch}
      >
      </TextField>
      <small style={{ textAlign: "right", width: "100%", display: "block" }}>*need to be connected to AWS VPN to view</small>
      <Table>
        <TableHeader>
          <TableHeaderCell>Project</TableHeaderCell>
          <TableHeaderCell>Interactive</TableHeaderCell>
          <TableHeaderCell>v1</TableHeaderCell>
          <TableHeaderCell>Dev</TableHeaderCell>
          <TableHeaderCell>Stage*</TableHeaderCell>
          <TableHeaderCell>Prod</TableHeaderCell>
        </TableHeader>
        {directories.filter(el => el.path.includes(searchTerm)).map(element => (
          <TableRow>
            <TableCell>{`${element.path.split("/")[0]}`}</TableCell>
            <TableCell>{`${element.path.split("/")[1]}`}</TableCell>
            <TableCell><a href={`${parseProj(element.path.split("/")[0]) + element.path.split("/")[1]}`} target="_blank" rel="noreferrer">v1</a></TableCell>
            <TableCell><a href={`https://music-interactive-listening-guides-wwnorton-medi-8ea0e462c0bfef.gitlab.io/#/${element.path}/interact`} target="_blank" rel="noreferrer">dev</a></TableCell>
            <TableCell><a href={`https://ilg.staging.wwnorton.net/v2/${element.path}/interact`} target="_blank" rel="noreferrer">stage</a></TableCell>
            <TableCell><a href={`https://ilg.wwnorton.com/v2/${element.path}/interact`} target="_blank" rel="noreferrer"><b>prod</b></a></TableCell>
          </TableRow>
        ))}
      </Table>
    </div>
  )
}

export default HomePage;